<template>
  <v-container fluid>
    <loading-overlay :visible="loading" :label="$t('app.states.loading')" />
    <div>
      <p v-if="milestones.length > 0">{{ $t("app.milestone.sub-title") }}</p>
      <v-row v-if="milestones.length > 0" dense>
        <v-col
          v-for="post in milestones"
          :key="post.id"
          cols="6"
          sm="6"
          md="4"
          lg="3"
        >
          <ProfileCard
            :link="`/?highlight=${post.id}`"
            :title="post.createdAt | moment('D MMMM YYYY')"
            :subtitle="post.milestone.title"
            :icon="post.milestone.icon.replace('.svg', '')"
          ></ProfileCard>
        </v-col>
      </v-row>
      <div v-else>
        <div class="display-message">
          <img
            :src="require('@/assets/images/baby-blue.svg')"
            alt="Baby icon"
          />
          <p class="pink--text" v-html="$t('app.milestone.intro')"></p>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { neoparentPosts } from "@/api";

export default {
  name: "neoparent-milestones",
  data() {
    return {
      milestones: [],
      loading: true
    };
  },
  async mounted() {
    try {
      const result = await neoparentPosts.getAllPostsForPatient(
        this.$store.getters.user.patient.id
      );
      this.milestones = result.data.posts.filter(
        post => post.milestoneId !== null
      );
      this.consoleLog(result);
    } catch (err) {
      this.consoleLog(err);
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style scoped lang="scss">
</style>
